/* import __COLOCATED_TEMPLATE__ from './warm-transfer-team-status.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type AdminSummary from 'embercom/objects/inbox/admin-summary';

interface Signature {
  Args: {
    status: 'declined' | 'no-answer';
    admin: AdminSummary;
  };
  Element: HTMLDivElement;
}

export default class WarmTransferTeamStatus extends Component<Signature> {
  @service declare intl: IntlService;

  get statusMessage(): string {
    let translationKey =
      this.args.status === 'declined'
        ? 'calling.modal.warm-transfer-team.declined'
        : 'calling.modal.warm-transfer-team.no-answer';

    return this.intl.t(translationKey, { name: this.args.admin.name });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::WarmTransferTeamStatus': typeof WarmTransferTeamStatus;
    'inbox2/calling/warm-transfer-team-status': typeof WarmTransferTeamStatus;
  }
}
